export const createLanguage = ({ BeURL, topInput, setLanguage, showAlert, handleTopClear }) => {
    if (!BeURL || !topInput || !setLanguage) {
        alert("BeURL, topInput or setLanguage is invalid")
        return
    }
    
    fetch(`${BeURL}/language`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ topInput })
    })
        .then(res => res.json())
        .then(data => {
            if (data.success) {
                showAlert(data.message)
                setLanguage(data.languages)
                handleTopClear()
            }
            else {
                showAlert(data.message)
            }
        })
        .catch(err => {
            console.log("Error in create language", err)
            showAlert("Trouble")
        })
        .finally({

        })

}
